import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import { capitalize } from '@Shared/utils/helpers';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IMoreDataFormMeta {
    serviceId: FormInputMeta;
    transactionId: FormInputMeta;
    referenceNumber: FormInputMeta;
    researchReferenceNumber: FormInputMeta;
    transmissionDateAndTime: FormInputMeta;
    systemTraceAuditNumber: FormInputMeta;
    //
    schema: any;
  }

const MoreDataFormMeta = {} as IMoreDataFormMeta;

MoreDataFormMeta.serviceId = {
  name: "serviceId",
  label: "Id service",
  type: "select",
  validation: yup.string().required("Ce champ est requis"),
};
MoreDataFormMeta.transactionId = {
  name: 'transactionId',
  type: 'text',
  label: 'ID transaction',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
MoreDataFormMeta.referenceNumber = {
  name: 'referenceNumber',
  type: 'text',
  label: 'Numero reference',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
MoreDataFormMeta.researchReferenceNumber = {
  name: 'researchReferenceNumber',
  type: 'text',
  label: 'Numero reference de recherche',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
MoreDataFormMeta.transmissionDateAndTime = {
  name: 'transmissionDateAndTime',
  type: 'text',
  label: 'Date et temps de transmission',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
MoreDataFormMeta.systemTraceAuditNumber = {
  name: 'systemTraceAuditNumber',
  type: 'text',
  label: 'Numero d\'audit de la trace du systeme',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};


MoreDataFormMeta.schema = yup.object().shape(getValidationSchema(MoreDataFormMeta));

export default MoreDataFormMeta;